import { PopularMetaregions } from './PopularMetaregions';

export default PopularMetaregions;
